export const RESTRICTED_AGENT_FILTER_KEYS = [
	"assignee_id",
	"participant_id",
	"created_by_id",
];

export const isRestrictedKanbanViewer = (board, role) =>
	!!board?.settings?.restrict_agent_view_to_own_tasks && role === "agent";

export const withoutRestrictedAgentFilters = (payload) => {
	if (!Array.isArray(payload) || !payload.length) return payload || [];

	return payload.filter((condition) => {
		const key = condition.attribute_key || condition.attributeKey;
		return !RESTRICTED_AGENT_FILTER_KEYS.includes(key);
	});
};
